export default __webpack_public_path__ + "static/media/003-backpack.2e5474fd.svg";